import { render, staticRenderFns } from "./DestinationSection.vue?vue&type=template&id=47a36a28&scoped=true&"
import script from "./DestinationSection.vue?vue&type=script&lang=js&"
export * from "./DestinationSection.vue?vue&type=script&lang=js&"
import style0 from "./DestinationSection.vue?vue&type=style&index=0&id=47a36a28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a36a28",
  null
  
)

export default component.exports